import request from '@/utils/request'

// 添加电子卡券
export const addVoucher = (formData) => {
    return request.post('/voucher', formData)
}

// 修改电子卡券
export const editVoucher = (updateData) => {
    return request.put('/voucher', updateData)
}

// 分页获取卡券记录
export const listVoucherUserPage = (pageData, formData) => {
    return request.post(`/voucher/user/page/${pageData.page}/${pageData.pageSize}`, formData)
}

// 新增卡券记录
export const addVoucherUser = (formData) => {
    return request.post('/voucher/user', formData)
}

// 获取卡券记录
export const detailVoucherUser = (id) => {
    return request.get(`/voucher/user/${id}`)
}

// 修改卡券记录
export const editVoucherUser = (updateData) => {
    return request.put('/voucher/user', updateData)
}